import { ApolloLink } from "@apollo/client";
const appReleaseLink = new ApolloLink((operation, forward)=>{
    operation.setContext(({ headers = {} })=>({
            headers: {
                ...headers,
                'creh-app-version': process.env.APP_VERSION || process.env.NEXT_PUBLIC_COMMIT_SHA,
                'creh-app-env': process.env.APP_ENV
            }
        }));
    return forward(operation);
});
const links_appReleaseLink = appReleaseLink;
export default links_appReleaseLink;
